export const setAttribute = (attribute, value, stopTrying = false) => {
  try {
    if (!!window.OptiMonk || !!window.OptiMonkEmbedded) {
      let OM = window.OptiMonk;
      let OME = window.OptiMonkEmbedded;
      let OMVisitor = !!OM ? OM.Visitor : null;
      let OMEVisitor = !!OME ? OME.Visitor : null;
      let Visitor = OMVisitor || OMEVisitor;
      if (!!Visitor) {
        const adapter = Visitor.createAdapter();
        adapter.attr(attribute, value);
        return true;
      }
    }
    if (!stopTrying) {
      setTimeout(() => {
        setAttribute(attribute, value, true);
      }, 2000);
    }
  } catch (error) {
    console.error('Optimonk setAttribute error', error);
  }
};

export const optimonkSetCart = (items, stopTrying = false) => {
  try {
    if (!!window.OptiMonk || !!window.OptiMonkEmbedded) {
      let OM = window.OptiMonk;
      let OME = window.OptiMonkEmbedded;
      let OMVisitor = !!OM ? OM.Visitor : null;
      let OMEVisitor = !!OME ? OME.Visitor : null;
      let Visitor = OMVisitor || OMEVisitor;
      if (!!Visitor) {
        let adapter = Visitor.createAdapter();
        adapter.Cart.clear();
        for (let item of items) {
          adapter.Cart.add(`${item.id}`, {
            quantity: item.quantity,
            price: item.price,
          });
        }
        return true;
      }
    }
    if (!stopTrying) {
      setTimeout(() => {
        optimonkSetCart(items, true);
      }, 2000);
    }
  } catch (error) {
    console.error('Optimonk cart error', error);
  }
};
